export default {
  name: "PasswordResetComplete",
  data() {
    return ({
      success_message: "Your password has been reset successfully!",
      snackbar_timeout_id: null,
    });
  },
  mounted() {
    this.start_snackbar_timer();
  },
  beforeUnmount() {
    this.clear_snackbar_timer();
  },
  methods: {
    clear_snackbar_timer() {
      if (this.snackbar_timeout_id) {
        clearTimeout(this.snackbar_timeout_id);
        this.snackbar_timeout_id = null;
      }
    },
    start_snackbar_timer() {
      this.clear_snackbar_timer();
      this.snackbar_timeout_id = setTimeout(() => {
        this.success_message = "";
        this.snackbar_timeout_id = null;
      }, 5000);
    },
    clear_success_message() {
      this.clear_snackbar_timer();
      this.success_message = "";
    }
  }
};
